import { AuthSuccessResult } from '../types/models';

export default function isAuthSuccessResult(
  result: any,
): result is AuthSuccessResult {
  return result.user_id && result.auth_token;
}
